import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { RootState, StateFromRoot, registerReducer, store } from "@core/store"
import { TgMailing } from "../interfaces"
import { GridPaginationModel } from "@mui/x-data-grid-pro"
import { GRID_PAGE_SIZE_OPTIONS } from "@/core/constants"

const STATE_KEY = "telegram"
export const CONFIG_KEY = `${STATE_KEY}_state`

type TableName = "usersTable" | "finishedMailingsTable"
const defaultTableState: GridPaginationModel = {
  page: 0,
  pageSize: GRID_PAGE_SIZE_OPTIONS[0],
}
export interface IMailingPrefill {
  name?: string
}
type IState = {
  [table in TableName]: GridPaginationModel
} & {
  mailingFilters: TgMailing.Filters
  users: string[]
  mailingPrefill: IMailingPrefill | null
}
// type StateFromRoot = { [STATE_KEY]: IState }

const persistantState = localStorage.getItem(CONFIG_KEY)
const emptyState: IState = {
  usersTable: defaultTableState,
  finishedMailingsTable: defaultTableState,
  mailingFilters: {},
  users: [],
  mailingPrefill: null,
  ...(persistantState && JSON.parse(persistantState)),
}

const initialState: IState = emptyState

export const telegramSlice = createSlice({
  name: "telegram",
  initialState: initialState,
  reducers: {
    setMailingFilters: (
      state,
      { payload: filters }: PayloadAction<TgMailing.Filters>,
    ) => {
      state.mailingFilters = filters
    },
    setUsers: (state, { payload: users }: PayloadAction<string[]>) => {
      state.users = users
    },
    setMailingPrefill: (state, { payload }: PayloadAction<IMailingPrefill>) => {
      state.mailingPrefill = payload
    },
    clearMailingPrefill: (state) => {
      state.mailingPrefill = null
    },
    setUsersTablePaginationModel: (
      state,
      { payload: model }: PayloadAction<GridPaginationModel>,
    ) => {
      state.usersTable = model
    },
    setFinishedMailingsTablePaginationModel: (
      state,
      { payload: model }: PayloadAction<GridPaginationModel>,
    ) => {
      state.finishedMailingsTable = model
    },
  },
})
registerReducer(telegramSlice.name, telegramSlice.reducer)
store.subscribe(() => {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(store.getState()[STATE_KEY]))
})

export const {
  setMailingFilters,
  setUsers,
  setMailingPrefill,
  clearMailingPrefill,
  setFinishedMailingsTablePaginationModel,
  setUsersTablePaginationModel,
} = telegramSlice.actions

export const getTelegramState = (state: RootState<StateFromRoot<IState>>) =>
  state.telegram
